import { render, staticRenderFns } from "./UnpaidInvoiceBanner.vue?vue&type=template&id=2a4ae94f&scoped=true"
import script from "./UnpaidInvoiceBanner.vue?vue&type=script&lang=js"
export * from "./UnpaidInvoiceBanner.vue?vue&type=script&lang=js"
import style0 from "./UnpaidInvoiceBanner.vue?vue&type=style&index=0&id=2a4ae94f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ae94f",
  null
  
)

export default component.exports